import React, { useEffect, useState } from 'react'
import { Chip } from 'primereact/chip'
import { Photo } from '../../models/media'
import FiltersBar from '../menus/FiltersBar'
import PhotoCard from './PhotoCard'
import { Paginator } from 'primereact/paginator'
import LoadingCircle from '../misc/LoadingCircle'
import './media.scss'
import { useWindowResize } from '../../utils/hooks'
import LuxButton from '../buttons/Button'
import CheckboxInput from '../form/CheckboxInput'

const PaginatedGallery = (props: {
    filters: any
    pageSize: number
    totalItems: number
    photoList: Photo[]
    onChangePage: (e) => void
    page?: number
    first?: number
    loading?: boolean
    colWidth?: number
    activeDot?: boolean
    filtersList?: any
    clearFilters?: any
    currentPageReport?: boolean
    rowsPerPageOptions?: number[]
    handleImageClick?: () => void
    onSelectAllChange?: (val: boolean, photoList: Photo[]) => void
    labels?: {
        selectMultiple?: string
        unselectAll?: string
        selectAll?: string
        showFilters?: string
        hideFilters?: string
        clearFilters?: string
        totalItems?: string
        selectedItems?: string
        noResults?: string
    }
    selectMultipleItems?: {
        selectionActive: boolean
        setSelectionActive: (val: boolean) => void
        selectedItems: number
    }
    photoActions?: {
        open: (photo: Photo) => void
        replace: (photo: Photo) => void
        delete: (photo: Photo) => void
    }
    additionalButtons?: {
        text?: string
        icon?: string
        variant?: string[]
        onClick?: () => void
    }[]
    setLoadedPhotos?: () => void
}) => {
    const {
        filters,
        pageSize,
        totalItems,
        photoList,
        onChangePage,
        page,
        first,
        loading,
        colWidth,
        activeDot,
        filtersList,
        clearFilters,
        currentPageReport,
        rowsPerPageOptions,
        handleImageClick,
        labels,
        selectMultipleItems,
        photoActions,
        onSelectAllChange,
        additionalButtons,
        setLoadedPhotos,
    } = props

    const isMobile = useWindowResize()

    const [pageState, setPageState] = useState(0)

    useEffect(() => {
        if (page || page === 0) setPageState(page)
    }, [page])

    const [showFilters, setShowFilters] = useState(false)

    // const [visible, setVisible] = useState(true)
    // todo loading
    return (
        <div className="p-grid p-py-3 p-px-5 gallery-container">
            {selectMultipleItems && (
                <div className="p-col-12 p-d-flex p-jc-between p-ai-center gallery-header">
                    <div className="p-d-flex p-ai-center gallery-header-first">
                        {filtersList && (
                            <>
                                <LuxButton
                                    activeDot={activeDot}
                                    variant={['outlined']}
                                    onClick={() => setShowFilters(!showFilters)}
                                    icon={
                                        showFilters
                                            ? 'filter-slash'
                                            : ' cu cu-filter'
                                    }
                                    text={
                                        showFilters
                                            ? labels?.selectMultiple
                                                ? labels.hideFilters
                                                : 'hide filters'
                                            : labels?.selectMultiple
                                            ? labels.showFilters
                                            : 'show filters'
                                    }
                                />
                            </>
                        )}
                        {selectMultipleItems && (
                            <>
                                <LuxButton
                                    classes={'select-more-photos-button'}
                                    variant={['text']}
                                    icon={
                                        selectMultipleItems.selectionActive
                                            ? 'times'
                                            : 'check-square'
                                    }
                                    text={
                                        selectMultipleItems.selectionActive
                                            ? labels?.selectMultiple
                                                ? labels.unselectAll
                                                : 'cancel selection'
                                            : labels?.selectMultiple
                                            ? labels.selectMultiple
                                            : 'select multiple photos'
                                    }
                                    onClick={() =>
                                        selectMultipleItems.setSelectionActive(
                                            !selectMultipleItems.selectionActive
                                        )
                                    }
                                />
                                {selectMultipleItems.selectionActive &&
                                    onSelectAllChange && (
                                        <CheckboxInput
                                            name="select_all"
                                            value={photoList.every(
                                                (p) => p.selected
                                            )}
                                            onChangeCallback={(event: any) =>
                                                onSelectAllChange(
                                                    event.checked,
                                                    photoList
                                                )
                                            }
                                            label={
                                                labels?.selectAll
                                                    ? labels.selectAll
                                                    : 'Select all'
                                            }
                                        />
                                    )}
                            </>
                        )}
                    </div>
                    <div className="gallery-header-second">
                        <Chip
                            icon="cu cu-camera"
                            label={
                                totalItems +
                                ' ' +
                                (labels?.totalItems
                                    ? labels.totalItems
                                    : 'total elements')
                            }
                        />
                        {selectMultipleItems?.selectionActive && (
                            <Chip
                                icon="pi pi-check-square"
                                label={
                                    selectMultipleItems.selectedItems +
                                    ' ' +
                                    (labels?.selectedItems
                                        ? labels.selectedItems
                                        : 'selected')
                                }
                            />
                        )}
                        {additionalButtons && additionalButtons?.length > 0
                            ? additionalButtons.map((b: any, i: number) => {
                                  return (
                                      <LuxButton
                                          key={i}
                                          icon={b?.icon}
                                          text={b?.text}
                                          variant={b?.variant || ['primary']}
                                          onClick={b?.onClick}
                                      />
                                  )
                              })
                            : null}
                    </div>
                </div>
            )}
            {filtersList && showFilters && (
                <FiltersBar
                    filters={filters}
                    filtersList={filtersList}
                    clearFilters={clearFilters}
                    labels={{ clearFilters: labels.clearFilters }}
                />
            )}
            <div className="p-grid p-col-12 gallery-grid p-py-0">
                {!loading &&
                    photoList.map((ph, i: number) => {
                        return (
                            <PhotoCard
                                key={i}
                                photo={ph}
                                photoActions={photoActions}
                                colWidth={colWidth ? colWidth : 3}
                                // when selection is active, handleImageClick must handle the selection
                                handleImageClick={handleImageClick}
                                selectionActive={
                                    selectMultipleItems?.selectionActive
                                }
                                onLoad={() =>
                                    setLoadedPhotos &&
                                    i === photoList.length - 1
                                        ? setLoadedPhotos()
                                        : null
                                }
                                isLastItem={
                                    setLoadedPhotos
                                        ? i === photoList.length - 1
                                        : false
                                }
                            />
                        )
                    })}
                {!loading && photoList.length === 0 && (
                    <strong className="p-col-12 p-my-auto">
                        {labels?.noResults
                            ? labels.noResults
                            : 'no results found.'}
                    </strong>
                )}
                <LoadingCircle active={loading} backdrop />
            </div>
            <div className="p-col-12 gallery-buttons">
                <Paginator
                    first={first || pageState}
                    rows={pageSize}
                    totalRecords={totalItems}
                    pageLinkSize={isMobile ? 3 : 5}
                    onPageChange={onChangePage}
                    currentPageReportTemplate={
                        currentPageReport
                            ? '{first} - {last} of {totalRecords}'
                            : undefined
                    }
                    rowsPerPageOptions={
                        rowsPerPageOptions ? rowsPerPageOptions : undefined
                    }
                    template={`${
                        currentPageReport ? 'CurrentPageReport' : ''
                    } ${
                        isMobile ? '' : 'FirstPageLink '
                    } PrevPageLink PageLinks NextPageLink ${
                        isMobile ? '' : 'LastPageLink '
                    } ${rowsPerPageOptions ? 'RowsPerPageDropdown' : ''}`}
                />
            </div>
            {/*<FormDialog
                header={
                    <div
                        style={{
                            // height: '30px',
                            // width: '30px',
                            backgroundColor: 'orange',
                            display: 'flex',
                        }}>
                        <i className="pi pi-sun"></i>
                        ciao
                    </div>
                }
                visible={visible}
                onHide={() => setVisible(false)}
                formFields={[{ type: INPUT_TYPE.select }]}
                additionalActions={
                    <div
                        style={{
                            height: '30px',
                            width: '30px',
                            backgroundColor: 'orange',
                        }}></div>
                }>
                blabla
            </FormDialog>*/}
        </div>
    )
}

export default PaginatedGallery
